import { ChecklistLogin } from "@features/checklist/components/checklist-login";
import { usePreventZoom } from "@hooks";
import { ClarityProvider } from "@providers";
import { Suspense } from "react";
import { ChecklistSteps } from "../components/checklist-steps";
import { useChecklistStore } from "../store";

export default function Checklist() {
	usePreventZoom();
	const checklist = useChecklistStore((state) => state.checklist);

	return (
		<Suspense fallback={<div>Loading...</div>}>
			<ClarityProvider />
			{checklist?.answerData ? <ChecklistSteps /> : <ChecklistLogin />}
		</Suspense>
	);
}
